import routeSettingsDefaults from "./routeSettingsDefaults";

const defaultParams = {
    loading: false,
    selected: false,
    error: false,
    routes: []
}

const allTransportModes = ['CAR','PUBLIC','FOOT','BIKE', 'MOTORCYCLE', 'PARK_AND_RIDE', 'BIKE_AND_RIDE', 'CAMPER','TRAILER',/*'SHARING','BIKE_SHARING','CAR_TRAIN' */];

function generateDefaultModes() {
    const selectedModes = routeSettingsDefaults.general.type;
    let modeDefaults = {};
    allTransportModes.forEach(modeKey => {
        modeDefaults[modeKey] = {...defaultParams};
        if(selectedModes.includes(modeKey)) {
            modeDefaults[modeKey].selected = true;
        }
    })
    return modeDefaults;
}

export default generateDefaultModes();
